import { render, staticRenderFns } from "./error-notification.vue?vue&type=template&id=0260bc56"
import script from "./error-notification.vue?vue&type=script&lang=js"
export * from "./error-notification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports